<template>
  <tr>
    <td v-if="isPC">
      {{ timestamp.format('LL') }}
      <br />
      {{ timestamp.format('LT') }}
    </td>
    <td v-if="isPC">
      <p
        v-if="
          from.idx === $store.state.auth.idx ||
            from.idx === $store.state.uncle.idx
        "
        style="color: red;"
      >송금</p>
      <p
        v-else-if="
          to.idx === $store.state.auth.idx || to.idx === $store.state.uncle.idx
        "
        style="color: green;"
      >입금</p>
      <p v-else>기타</p>
    </td>
    <td v-if="isPC">
      <p>{{ reason }}</p>
    </td>
    <td v-if="isPC">
      <p>{{ from.username || '없음' }}</p>
    </td>
    <td v-if="isPC">
      <p>{{ to.username || '없음' }}</p>
    </td>
    <td v-if="isPC">{{ parseInt(amount || '0').toLocaleString() }}원</td>
    <td v-else style="text-align: left; padding: 1em;">
      <dl>
        <dt>시간:</dt>
        <dd>{{ timestamp.format('llll') }}</dd>
        <dt>타입:</dt>
        <dd>
          <p
            v-if="
              from.idx === $store.state.auth.idx ||
                from.idx === $store.state.uncle.idx
            "
            style="color: red;"
          >송금</p>
          <p
            v-else-if="
              to.idx === $store.state.auth.idx ||
                to.idx === $store.state.uncle.idx
            "
            style="color: green;"
          >입금</p>
          <p v-else>기타</p>
        </dd>
        <dt>사유:</dt>
        <dd>{{ reason }}</dd>
        <dt>발신인:</dt>
        <dt></dt>
        <dd>{{ from.username || '없음'}}</dd>
        <dt>수취인:</dt>
        <dt></dt>
        <dd>{{ to.username || '없음' }}</dd>
        <dt>금액:</dt>
        <dd>{{ parseInt(amount || '0').toLocaleString() }}원</dd>
      </dl>
    </td>
  </tr>
</template>
<script>
export default {
  name: "HistoryItem",
  props: ["from", "to", "amount", "timestamp", "reason"]
};
</script>
